import {
  EAffiliateCampaignDeliveryType,
  ECampaignType,
  EReasonDeliveryOrderSample,
  ESubmitStatus,
  ReasonEnum
} from "@/modules/helpers/enum"

export const TIKTOK_SCOPE =
  "user.info.profile,aweme.share,user.info.basic,user.info.stats,video.list"

export const CAMPAIGN_TYPE_CONTENT = {
  [ECampaignType.COST_PER_VIEW]: "Trả phí theo lượt xem",
  [ECampaignType.REVIEW_PRODUCT]: "Review sản phẩm",
  [ECampaignType.AFFILIATE]: "Mẫu miễn phí"
}

export const AFFILIATE_CAMPAIGN_TYPE_DELIVERY_CONTENT: Record<
  EAffiliateCampaignDeliveryType,
  string
> = {
  [EAffiliateCampaignDeliveryType.NORMAL]: "Mẫu miễn phí",
  [EAffiliateCampaignDeliveryType.SEND_OUTSIDE]: "Gửi ngoài sàn TikTok"
}

export const SUBMISSION_STATUS_CONTENT = {
  [ESubmitStatus.APPLIED]: "Chờ nhận hàng",
  [ESubmitStatus.BRAND_APPROVED]: "Chờ nhận hàng",
  [ESubmitStatus.FINISHED]: "Đã hoàn thành",
  [ESubmitStatus.REJECTED]: "Nhãn hàng từ chối",
  [ESubmitStatus.WAITING]: "Đang chờ phản hồi",
  [ESubmitStatus.WORKING]: "Đã được duyệt",
  [ESubmitStatus.NOT_ATTACH_LINK]: "Chưa gắn liên kết",
  [ESubmitStatus.PREVIOUSLY_RECEIVED]: "Nhãn hàng gửi trực tiếp",
  [ESubmitStatus.NOT_AUTHORIZED_ORDER_SAMPLE]: "Chưa ủy quyền đặt hàng",
  [ESubmitStatus.OVERDUE]: "Quá hạn"
}

export const SUBMISSION_STATUS_CONTENT_V2 = {
  [ESubmitStatus.APPLIED]: "Duyệt - Chờ nhận hàng",
  [ESubmitStatus.BRAND_APPROVED]: "Duyệt - Chờ nhận hàng",
  [ESubmitStatus.FINISHED]: "Đã hoàn thành",
  [ESubmitStatus.REJECTED]: "Nhãn hàng từ chối",
  [ESubmitStatus.WAITING]: "Đang chờ phản hồi",
  [ESubmitStatus.WORKING]: "Đã được duyệt",
  [ESubmitStatus.NOT_ATTACH_LINK]: "Chưa gắn liên kết",
  [ESubmitStatus.PREVIOUSLY_RECEIVED]: "Nhãn hàng gửi trực tiếp",
  [ESubmitStatus.NOT_AUTHORIZED_ORDER_SAMPLE]: "Chưa ủy quyền đặt hàng",
  [ESubmitStatus.OVERDUE]: "Quá hạn"
}

export const REASON_DELIVERY_ORDER_SAMPLE_CONTENT: Record<EReasonDeliveryOrderSample, string> = {
  [EReasonDeliveryOrderSample.NOT_ATTACH_LINK]: "Chưa gắn liên kết",
  [EReasonDeliveryOrderSample.PREVIOUSLY_RECEIVED]: "Đã nhận mẫu trước đó",
  [EReasonDeliveryOrderSample.NOT_AUTHORIZED_ORDER_SAMPLE]: "Chưa ủy quyền đặt mẫu"
}

export const REASON_COMPLAINT = {
  [ReasonEnum.PRODUCT_NOT_RECEIVED]: "Chưa nhận được sản phẩm",
  [ReasonEnum.WRONG_PRODUCT_SENT]: "Brand gửi nhầm sản phẩm",
  [ReasonEnum.INCOMPLETE_PREVIOUS_JOBS]: "Chưa trả xong các job đã nhận trước",
  [ReasonEnum.DEMO_NOT_APPROVED]: "Demo chưa được brand duyệt",
  [ReasonEnum.OTHER]: "Khác"
}
